import { MoreOutlined } from "@ant-design/icons";
import styled from "styled-components";

export const RouteItem = styled.div`
    background-color: ${(props) => props.theme.secondaryBackgroundColor};
    border: 1px solid ${(props) => props.theme.secondaryBorderColor};
    border-radius: 10px;
    margin-bottom: 8px;
    display: flex;
    padding: 16px;
    gap: 8px;
    flex-direction: column;
    align-items: flex-start;
`;

export const StyledRouteDropdown = styled.div`
    .ant-dropdown-menu {
        padding: 8px 0px !important;
    }

    .ant-dropdown-menu-item {
        padding: 8px 16px !important;
    }
`;

export const StyledMoreOutlined = styled(MoreOutlined)`
    color: ${({ theme }) => theme.primaryTypographyColor};
    font-size: 24px;
`;
